import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts';
import type { ReactNode } from 'react';
import { palette } from './chartTheme';
import { ChartTooltip } from './ChartTooltip';

interface DonutSlice {
  name: string;
  value: number;
}

interface DonutChartProps {
  data: DonutSlice[];
  height?: number;
  innerRadius?: number;
  outerRadius?: number;
  formatValue?: (v: number) => ReactNode;
  onSliceClick?: (slice: DonutSlice) => void;
}

export function DonutChart({
  data,
  height = 220,
  innerRadius = 60,
  outerRadius = 92,
  formatValue,
  onSliceClick,
}: DonutChartProps) {
  return (
    <div style={{ width: '100%', height }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius={innerRadius}
            outerRadius={outerRadius}
            stroke={palette.surface()}
            strokeWidth={2}
            isAnimationActive={false}
            paddingAngle={1}
            cursor={onSliceClick ? 'pointer' : undefined}
            onClick={(slice) => {
              if (onSliceClick) onSliceClick(slice as DonutSlice);
            }}
          >
            {data.map((_, i) => (
              <Cell key={i} fill={palette.series[i % palette.series.length]()} />
            ))}
          </Pie>
          <Tooltip content={(p) => <ChartTooltip {...p} formatValue={formatValue} />} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
